import React from 'react'

export default function GeneralList() {
  const data:any = [
   
    {},
    {},

  ];
  return (
    <div className=' container'style={{margin:"30px"}} >
      {/* title */}
<h5>GeneralList Screen <span> <i className="fa-solid fa-list m-2"></i>    </span>   </h5>
<label htmlFor="">Choose File Type :</label>
<select name="" id=""className='  p-1 ' style={{marginLeft:"7px",width:"25%"}}>
  

  <option value="pre">Pre-Authorization Code List</option>
  <option value="ICDlist">Not Covered ICD List</option>
  <option value="principle">Not Allowed  Principles Code List</option>

   </select>  <span><a href="/" style={{marginLeft:"30px"}}>Click to Download template</a></span> 
{/* first row input */}
<div className=' row'>
<div className="input-group w-50  " style={{marginTop:"50px"}}>
  <input type="file" className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload"/>
  
  <button className="btn btn-secondary" type="submit"  style={{marginLeft:"10px", padding:"8px"}}> <span className=' m-1 '><i className="fa-solid fa-upload"></i></span>Upload</button>
</div>

</div>
{/* Second row input */}

{/* <div className=' row d-flex flex-row w-100 ' style={{ marginTop:"20px"}}>
 <select name="PlanName" id=""className='  p-1 ' style={{marginLeft:"7px",width:"25%"}}>
  

<option value="PlanName">PlanName</option>

 </select>
 <input type="text" className="form-control " placeholder="Code"style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>


   <input type="text" className="form-control " placeholder="Search "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>




</div> */}
<div className='row p-3  shadow-lg' style={{marginTop:"20px"}}>
    <div className="col-md-6 d-flex flex-column  align-items-center  "> 
    <input  type="text" className="form-control " placeholder="PlanName"style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

   <input                  type="text" className="form-control "  placeholder="Code "style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

   <button className="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Add New GeneralList
          </button>
             </div>


    <div className="col-md-6 d-flex flex-column  align-items-center   " >
    <input type="text" className="form-control text-center " placeholder=" "style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>
    <button className=' btn btn-success' style={{width:"25%"}}>Search</button>

    </div>

</div>
<div className="modal fade" id="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Add Item</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
                </div>
              
                <div className=' container d-flex flex-column align-items-center '>
  

  



   <label className='m-2'>PlanName :</label>

   <select name="PlanName" id=""className='  p-1 ' style={{marginBottom:"10px",width:"50%"}}>
  

  <option value=""></option>
  
   </select>
   <label className='m-2'>Code :</label>
   <input type="text" className="form-control " placeholder=" "style={{marginBottom:"10px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

        </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary"   >
                  Add Item
                  
                  </button>
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>

{/* table */}
<table className=' text-center' style={{  width: '100%' , marginTop:"40px", color:"white"  }}>
      <thead className=' bg-success'>
        <tr>
          <th style={{ border: '1px solid #ddd', padding: '5px' }}>Plan Name</th>
          <th style={{ border: '1px solid #ddd', padding: '5px' }}>Code</th>
          <th style={{ border: '1px solid #ddd', padding: '5px' }}>Actions</th>

        </tr>
      </thead>
      <tbody>
        {data.map((item:any,index:number) => (
          <tr key={item.id} className=' text-center' style={{
            // background: index % 2 === 0 ? '#74C0FC' : '#ffffff', // 
            border: '1px solid #ddd',
            padding: '8px',
            color:"black"
          }}>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.code}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}> <span>  <button className="btn btn-danger m-2"><i className=" fa fa-trash"></i></button></span></td>          </tr>
          
        ))}
      </tbody>
    </table>
 
    </div>
  )
}
